import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function TermsPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <header className="border-b border-slate-100 bg-white/90 backdrop-blur-lg sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2"><img src="/logo.jpg" alt="Smartpriced" className="h-8" /></Link>
          <LanguageSwitcher />
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-black text-slate-900 mb-2">{t("terms.title")}</h1>
        <p className="text-sm text-slate-500 mb-10">Laatst bijgewerkt: Februari 2026</p>
        <div className="prose prose-slate prose-sm max-w-none [&_h3]:text-lg [&_h3]:font-bold [&_h3]:mt-10 [&_h3]:mb-3 [&_p]:leading-relaxed">

          <h3>1. Definities</h3>
          <ul>
            <li>{t("terms.company_def")}</li>
            <li>{t("terms.customer_def")}</li>
          </ul>

        </div>
      </main>
    </div>
  );
}
